<div class="flex-row flex-1 flex-space-btw-center baseline">
  <div class="flex-row flex-1">
    <ng-container [formGroup]="form">
      <mat-form-field class="note-form-field">
        <mat-label>{{ isPreexistingNote ? 'Edit Note' : 'Create Note' }}</mat-label>
        <textarea data-testid="textarea-note" matInput cdkFocusInitial formControlName="note"></textarea>
        <mat-error>{{ form.get('note')?.errors | formatError }}</mat-error>
      </mat-form-field>
    </ng-container>
  </div>
  <div class="button-list flex-row flex-space-btw-center">
    <button
      data-testid="save-note"
      mat-icon-button
      [disabled]="form.pristine || form.invalid"
      (click)="isPreexistingNote ? onSaveNote() : onCreateNote()"
    >
      <mat-icon>save</mat-icon>
    </button>
    <button mat-icon-button (click)="cancel.emit()" color="accent">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
